/**
 * Historia 120 — Bloques 27/28 (Jupiter, ENMIENDAS 06 y 07) --
 * `features/S233-ui-previsualizacion-y-barra-de-lote-jupiter.feature` (S233) y
 * `features/S240-cierre-en-tabla-y-nombre-del-job-jupiter.feature` (S240).
 *
 * La restricción de altura que comparten las tablas de los DOS diálogos de lote — la previsualización
 * de inicio y la de cierre — para que ninguno crezca con la tanda. Vive aquí, y no duplicada en cada
 * diálogo, porque los dos escenarios que la verifican dicen lo mismo y tienen que poder seguir
 * diciéndolo si el valor cambia.
 *
 * 🔒 Va como `style` y no como `sx` a propósito: es una restricción que un escenario verifica, y `sx`
 * compila a una clase de emotion que jsdom no resuelve de forma fiable, mientras que `style` se lee
 * siempre del propio nodo.
 *
 * 🔒 **S114: la tabla genérica del proyecto (`generic/SmartMateriaUITable.jsx`) NO se toca.** Las dos
 * tablas de lote son MUI a secas, propias de sus diálogos.
 */
export const BATCH_TABLE_CONTAINER_STYLE = { overflow: 'auto', maxHeight: '18rem' }
